
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../../components/feature/Navbar';
import { Footer } from '../../components/feature/Footer';
import { Card } from '../../components/base/Card';
import { Button } from '../../components/base/Button';

export default function ProjectsPage() {
  const [activeTab, setActiveTab] = useState('Tümü');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCity, setSelectedCity] = useState('Tümü');

  const tabs = ['Tümü', 'Devam Eden', 'Tamamlanan', 'Gelecek'];
  const cities = ['Tümü', 'İstanbul', 'Ankara', 'İzmir', 'Bursa'];

  const projects = [
    {
      id: 1,
      title: 'Ataşehir Residence',
      location: 'Ataşehir, İstanbul',
      area: '15.000 m²',
      status: 'Devam Eden',
      statusColor: 'bg-blue-500',
      city: 'İstanbul',
      description: 'Modern yaşam konsepti ile tasarlanan lüks konut projesi',
      image: 'https://public.readdy.ai/ai/img_res/a9cdeef11c62c3a52b9aa88da14f1406.jpg',
      startDate: '2023',
      endDate: '2025'
    },
    {
      id: 2,
      title: 'Kadıköy Plaza',
      location: 'Kadıköy, İstanbul',
      area: '8.500 m²',
      status: 'Tamamlanan',
      statusColor: 'bg-green-500',
      city: 'İstanbul',
      description: 'Ticari ve ofis alanlarından oluşan çok fonksiyonlu plaza',
      image: 'https://readdy.ai/api/search-image?query=completed%20modern%20commercial%20plaza%20building%20with%20glass%20facade%2C%20contemporary%20office%20architecture%2C%20urban%20commercial%20development%2C%20clean%20background%2C%20professional%20photography%20style&width=400&height=300&seq=8&orientation=landscape',
      startDate: '2021',
      endDate: '2023'
    },
    {
      id: 3,
      title: 'Beşiktaş Towers',
      location: 'Beşiktaş, İstanbul',
      area: '22.000 m²',
      status: 'Gelecek',
      statusColor: 'bg-orange-500',
      city: 'İstanbul',
      description: 'İkiz kuleler konsepti ile tasarlanan prestijli proje',
      image: 'https://readdy.ai/api/search-image?query=future%20modern%20twin%20towers%20architectural%20rendering%2C%20contemporary%20high-rise%20building%20design%2C%20urban%20skyline%20development%20project%2C%20clean%20background%2C%20professional%20architectural%20visualization&width=400&height=300&seq=9&orientation=landscape',
      startDate: '2025',
      endDate: '2027'
    },
    {
      id: 4,
      title: 'Ankara Business Center',
      location: 'Çankaya, Ankara',
      area: '12.000 m²',
      status: 'Tamamlanan',
      statusColor: 'bg-green-500',
      city: 'Ankara',
      description: 'Modern iş merkezi ve konferans salonları',
      image: 'https://readdy.ai/api/search-image?query=modern%20business%20center%20building%20with%20glass%20and%20steel%20facade%2C%20contemporary%20office%20complex%20architecture%2C%20professional%20commercial%20building%20design%2C%20clean%20background&width=400&height=300&seq=10&orientation=landscape',
      startDate: '2020',
      endDate: '2022'
    },
    {
      id: 5,
      title: 'İzmir Coastal Residence',
      location: 'Karşıyaka, İzmir',
      area: '18.000 m²',
      status: 'Devam Eden',
      statusColor: 'bg-blue-500',
      city: 'İzmir',
      description: 'Deniz manzaralı lüks konut kompleksi',
      image: 'https://readdy.ai/api/search-image?query=coastal%20residential%20complex%20under%20construction%20with%20sea%20view%2C%20modern%20apartment%20buildings%20near%20waterfront%2C%20contemporary%20housing%20development%2C%20clean%20background&width=400&height=300&seq=11&orientation=landscape',
      startDate: '2024',
      endDate: '2026'
    },
    {
      id: 6,
      title: 'Bursa Green Valley',
      location: 'Nilüfer, Bursa',
      area: '25.000 m²',
      status: 'Gelecek',
      statusColor: 'bg-orange-500',
      city: 'Bursa',
      description: 'Çevre dostu yeşil bina konsepti ile tasarlanan proje',
      image: 'https://readdy.ai/api/search-image?query=eco-friendly%20green%20building%20complex%20architectural%20rendering%2C%20sustainable%20residential%20development%20with%20gardens%2C%20modern%20environmental%20architecture%20design%2C%20clean%20background&width=400&height=300&seq=12&orientation=landscape',
      startDate: '2026',
      endDate: '2028'
    }
  ];

  const filteredProjects = projects.filter(project => {
    const matchesTab = activeTab === 'Tümü' || project.status === activeTab;
    const matchesSearch = project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         project.location.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCity = selectedCity === 'Tümü' || project.city === selectedCity;
    
    return matchesTab && matchesSearch && matchesCity;
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero */}
      <section className="pt-24 pb-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-[28px] font-bold text-[#0e3851] mb-4">
              Projelerimiz
            </h1>
            <p className="text-[16px] text-gray-600 max-w-3xl mx-auto">
              Kaliteli inşaat anlayışımızla hayata geçirdiğimiz konut ve ticari projeler
            </p>
          </div>
        </div>
      </section>

      {/* Filtreler */}
      <section className="py-8 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Tab Filtreleri */}
          <div className="flex flex-wrap justify-center gap-2 mb-6">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-6 py-2 rounded-full text-[14px] font-medium transition-all duration-200 whitespace-nowrap ${
                  activeTab === tab
                    ? 'bg-[#0e3851] text-white'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Arama ve Şehir Filtresi */}
          <div className="flex flex-col md:flex-row gap-4 justify-center">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"></i>
              <input
                type="text"
                placeholder="Proje ara..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[14px] w-full md:w-64"
              />
            </div>
            <select
              value={selectedCity}
              onChange={(e) => setSelectedCity(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#0e3851] focus:border-transparent text-[14px] pr-8"
            >
              {cities.map((city) => (
                <option key={city} value={city}>{city}</option>
              ))}
            </select>
          </div>
        </div>
      </section>

      {/* Projeler Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {filteredProjects.length === 0 ? (
            <div className="text-center py-12">
              <i className="ri-search-line text-[48px] text-gray-300 mb-4"></i>
              <h3 className="text-[18px] font-semibold text-gray-600 mb-2">Proje bulunamadı</h3>
              <p className="text-[15px] text-gray-500">Arama kriterlerinizi değiştirerek tekrar deneyin.</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredProjects.map((project) => (
                <Card key={project.id} hover>
                  <div className="relative">
                    <img 
                      src={project.image}
                      alt={project.title}
                      className="w-full h-48 object-cover rounded-xl mb-4"
                    />
                    <span className={`absolute top-3 right-3 px-3 py-1 rounded-full text-white text-[12px] font-medium ${project.statusColor}`}>
                      {project.status}
                    </span>
                  </div>
                  <h3 className="text-[18px] font-semibold text-[#0e3851] mb-2">{project.title}</h3>
                  <div className="space-y-1 mb-3">
                    <div className="flex items-center text-[14px] text-gray-600">
                      <i className="ri-map-pin-line mr-2"></i>
                      {project.location}
                    </div>
                    <div className="flex items-center text-[14px] text-gray-600">
                      <i className="ri-ruler-line mr-2"></i>
                      {project.area}
                    </div>
                    <div className="flex items-center text-[14px] text-gray-600">
                      <i className="ri-calendar-line mr-2"></i>
                      {project.startDate} - {project.endDate}
                    </div>
                  </div>
                  <p className="text-[14px] text-gray-600 mb-4 line-clamp-2">
                    {project.description}
                  </p>
                  <Link to={`/projeler/${project.id}`}>
                    <Button variant="outline" size="sm" className="w-full">
                      <i className="ri-eye-line mr-2"></i>
                      Detayları Gör
                    </Button>
                  </Link>
                </Card>
              ))}
            </div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
